// extracted by mini-css-extract-plugin
export default {"group":"DraggableList_group__nL1cp","icon":"DraggableList_icon__ExCYP","iconLarger":"DraggableList_iconLarger__StzDg","iconHover":"DraggableList_iconHover__3Kve7"};